import PosterCarousel from "./PosterCarousel";
import QueryBoundary from "../../components/ui/QueryBoundary";
import useApiQuery from "../../hooks/useApiQuery";
import endpoints from "../../api/endpoints";
import { mergeCatalog } from "../../lib/catalog";

const BookmarksTab = () => {
  // `bookmarks` nests the two lists; mergeCatalog handles the videos/series keys.
  const query = useApiQuery(endpoints.profile(), {
    select: (data) => mergeCatalog(data.bookmarks),
  });

  return (
    // The original showed a spinner forever when the list came back empty,
    // because "no bookmarks" and "still loading" shared the same branch.
    <QueryBoundary
      {...query}
      isEmpty={(items) => items.length === 0}
      emptyMessage="هنوز چیزی نشان نکرده‌اید."
    >
      {(items) => <PosterCarousel items={items} />}
    </QueryBoundary>
  );
};

export default BookmarksTab;
